import React , { useState } from 'react'



export default function FooterLight() {

  return (
    <div
        className='dontPrint'
        style={{
            width: '100%',
            color: "#FFF",
            background: '#292929',
            fontSize: '14px',
            textAlign: 'center',
            padding: "200px 0 0 0",
        }}
    >
        <hr
        style={{
          width: '100%',
          margin: '0',
        }}
      >
      </hr> 
      <div
        style={{
          display:'flex',
          justifyContent: 'space-evenly',
          padding: '3px 0 16px 0',
        }}
      >
        <p
          style={{
            margin: '0',
          }}
        >
          Copyright © 2024 Research Synthase
        </p>
        <a
            href="/termsofuse"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: '0',
              textDecoration: 'none',
              color: '#FFF'
            }}
        >
            Terms of Use
        </a>        
        <p
          style={{
            margin: '0',
          }}
        >
          Contact: cataractpreop@gmail.com
        </p>
      </div>
    </div>
  )
}
